import { useEffect, useState } from "react";

interface QuickWorklogTextInputProps {
    value: string;
    onFieldUpdate: (fieldName: string, newValue: string) => void;
    onKeyDown: React.Dispatch<React.SetStateAction<boolean>>;
    fieldName: string;
    className?: string;
    reference?: React.RefObject<HTMLInputElement>;
    autofocus?: boolean
}

export const QuickWorklogTextInput = ({ value, onFieldUpdate, onKeyDown, fieldName, className, reference, autofocus=false }: QuickWorklogTextInputProps) => {
    const [localValue, setLocalValue] = useState(value);

    const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalValue(event.target.value);
    };

    const handleValueUpdate = () => {
        onFieldUpdate(fieldName, localValue);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            onFieldUpdate(fieldName, localValue);
            onKeyDown(true);
        }
    };

    // Synchronize local state with the prop
    useEffect(() => {
      setLocalValue(value);
    }, [value]);

    return (
        <input
            autoFocus={autofocus}
            ref={reference}
            className={className}
            type="text"
            value={localValue}
            onChange={handleValueChange}
            onBlur={handleValueUpdate}
            onKeyDown={handleKeyDown}
        />
    );

}